import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    position: 'relative',
    borderBottom: `1px solid ${theme.palette.action.disabledBackground}`,
    padding: `${theme.spacing(2)}px 0`,
  },
  leftIcon: {
    position: 'absolute',
    top: 10,
    left: 0,
    width: 40,
    height: 40,
    borderRadius: 40,
    backgroundColor: theme.palette.action.disabled,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.colors.white,
  },
  textContainer: {
    width: 'calc(100% - 50px)',
    marginLeft: 50,
  },
  dateRow: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: 12,
    marginBottom: theme.spacing(1),
    fontStyle: 'italic',
  },
  date: {
    marginRight: theme.spacing(3),
  },
  correctionContainer: {
    marginBottom: theme.spacing(1),
    fontSize: 13,
  },
  bold: {
    fontWeight: 'bold',
  },
  text: {
    fontSize: 14,
  },
  author: {
    marginRight: theme.spacing(2),
  },
  imagesContainer: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    marginTop: theme.spacing(1),
  },
  image: {
    width: 110,
    height: 110,
    '& .MuiButton-label > div': {
      width: '100%',
    },
  },
  whiteIcon: {
    color: theme.colors.white,
  },
}));

export default useStyles;
